export const selectLoguedUser = ({ AuthSlice: oState }) => oState?.oUser;
export const selectLogoutAction = ({ AuthSlice: oState }) => oState?.bLogout;
export const selectBackAction = ({ AuthSlice: oState }) => oState?.bLogout;
export const selectManualFile = ({ AuthSlice: oState }) => oState?.sManual;
